// extracted by mini-css-extract-plugin
export default {"checkbox-v2":"checkbox-v2__hQe3HkqHxw7r"};